<template>
  <b-modal id="link-modal" v-model="isOpen" centered :title="title" hide-footer @close="isOpen = false">
    <div class="m-link">
      <copy-field :text="link" @copied="onCopy"></copy-field>

      <div v-if="success" class="success">
        <svg-icon class="success__icon" name="check" color="success" size="14"></svg-icon>
        Ссылка скопирована в буфер обмена
      </div>

      <div class="m-link__actions">
        <c-button class="m-link__close" label="Закрыть" @click="close" />
      </div>
    </div>
  </b-modal>
</template>

<script>
import Button from "@/components/controls2/Button";
import SvgIcon from "@/components/svg-icon";
import CopyField from "@/components/copy-field";

export default {
  name: "m-link",
  components: {
    "c-button": Button,
    CopyField,
    SvgIcon,
  },
  props: ["title"],
  data() {
    return {
      isOpen: false,
      link: "",
      success: false,
      successTimer: null,
    };
  },
  methods: {
    open(link) {
      this.link = link;
      this.isOpen = true;
    },
    close() {
      this.isOpen = false;
    },
    onCopy() {
      clearTimeout(this.successTimer);
      this.success = true;
      this.successTimer = setTimeout(() => {
        clearTimeout(this.successTimer);
        this.success = false;
      }, 3000);
    },
  },
};
</script>

<style lang="scss" scoped>
@import "~@/assets/styles/vars";
.m-link {
  .success {
    color: $color-success;
    font-size: 13px;
    display: flex;
    align-items: center;
    margin-top: 15px;

    &__icon {
      margin-right: 12px;
    }
  }

  &__actions {
    margin-top: 30px;
    display: flex;
    justify-content: flex-end;
  }

  @include onlyMobile {
    &__close {
      border-radius: 0 !important;
      width: 100%;
    }
    &__actions {
      margin: 30px -20px -20px;
    }
  }
}
</style>

<style lang="scss">
#link-modal {
  .modal-content {
    height: auto;
  }
}
</style>
